import { useEffect, useState } from "react";
import { ProfileAvatar, type PublicProfile } from "./ProfileAvatar";
import { publicProfile } from "./public-profile";
// Pass only identities already revealed by the member-authorized round API.
export function PlayerIdentity({ did }: { did: string }) {
  const [loaded, setLoaded] = useState<PublicProfile | null>(null);
  useEffect(() => {
    let current = true;
    void publicProfile(did).then((profile) => {
      if (current) setLoaded(profile);
    });
    return () => {
      current = false;
    };
  }, [did]);
  const profile = loaded?.did === did ? loaded : null;
  return (
    <span className="player-identity">
      <ProfileAvatar
        key={`${did}:${profile?.avatar ?? "no-photo"}`}
        actor={profile ?? { did, handle: did }}
      />
      <span className="player-identity-text">
        {profile ? (
          <>
            <strong>{profile.displayName || profile.handle}</strong>
            <span>@{profile.handle}</span>
          </>
        ) : (
          <span>{did}</span>
        )}
      </span>
    </span>
  );
}
